import { linkButtonClasses } from "@/helpers/style.helpers";
import { useRef } from "react";
interface ComponentProps {
  onChange: (value: string) => void;
  defaultValue?: string;
}

const QrCodeInputField: React.FC<ComponentProps> = ({ onChange, defaultValue }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const handleManualInput = () => {
    if (inputRef.current?.value) {
      onChange(inputRef.current.value.trim());
    }
  };

  return (
    <div className="flex mt-4">
      <input
        ref={inputRef}
        type="text"
        placeholder="Manuele QR code input"
        className="w-full"
        defaultValue={defaultValue}
      />
      <button className={linkButtonClasses} onClick={handleManualInput}>
        Use
      </button>
    </div>
  );
};

export default QrCodeInputField;
